module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card",
    class: _vm.flip,
    style: (_vm.styleSize)
  }, [_c('div', {
    staticClass: "card-flipper"
  }, [_c('div', {
    staticClass: "front",
    style: (_vm.styleBackground)
  }), _vm._v(" "), _c('div', {
    staticClass: "back",
    style: (_vm.styleImage)
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-160eaf12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageLoader.vue
// module id = 129
// module chunks = 2